import React, { useState } from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

import noteActions from 'src/store/model/note';
import { deleteNote, updateNote } from 'src/thunks/note';
import { useAppDispatch } from 'src/store';
import { useConfirm } from 'src/hooks';
import { TextArea } from 'src/components/coreUI/index';

const Note: React.FC<Model.Note> = (props) => {
  const { note } = props;
  const dispatch = useAppDispatch();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { Confirm, open } = useConfirm();

  return isEdit ? (
    <TextArea
      value={note}
      onSend={async (html) => {
        if (!html) return;
        setIsEdit(false);
        dispatch(noteActions.updateEntity({ ...props, note: html }));

        await dispatch(updateNote({ ...props, note: html }));
      }}
      onEsc={() => setIsEdit(false)}
    />
  ) : (
    <div className="d-flex justify-between">
      <React.Fragment>
        <div className="mr-8 whitespace-pre-line">{note}</div>
        <Dropdown
          icon={null}
          direction="left"
          trigger={<Icon name="ellipsis horizontal" color="grey" />}
        >
          <Dropdown.Menu style={{ top: '20%' }}>
            <Dropdown.Item onClick={() => setIsEdit(true)}>Edit</Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                open({
                  title: 'Confirm delete!',
                  content: 'Are you sure to delete this note?',
                  async onOk() {
                    await dispatch(deleteNote(props));
                  },
                });
              }}
            >
              Delete
            </Dropdown.Item>
            <Dropdown.Item>Download</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Confirm />
      </React.Fragment>
    </div>
  );
};

export default Note;
